import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import "../../Sass/Common.scss";
import PageLoading from "../../Components/Common/PageLoading";
import PatientsCreateAndEdit from "../../Components/Patients/PatientsCreateAndEdit";
import { ReactComponent as PatientDetails } from "../../Assets/Icons/PharmsmartIcon/PatientDetails.svg";

// const PatientsCreateAndEdit = React.lazy(() =>
//   import("Components/Patients/PatientsCreateAndEdit")
// );

const useStyle = makeStyles((theme) => ({
  rsUpdateDialog: {
    "&>div": {
      "&>div": {
        background: "#efefef",
        maxHeight: "calc(100% - 20px)",
        padding: "10px 0px",
        borderRadius: "10px !important",
        "&>div:nth-child(1)": {
          "&>h2": {
            "&>p": {
              paddingBottom: "10px",
            },
          },
          "&>div:nth-child(1)": {
            // paddingTop: "10px",
            "&>svg": {
              height: "50px",
              width: "50px",
            },
          },
        },
      },
    },
    "&>div:nth-child(3)": {
      "&>div": {
        // "&>div": {
        //   padding: "10px 0px",
        // },
      },
    },
    // [theme.breakpoints.down(1400)]: {
    //   maxWidth: "75% !important",
    // },
    // [theme.breakpoints.down(1000)]: {
    //   maxWidth: "95% !important",
    // },
    "& .MuiPaper-root.MuiPaper-elevation": {
      top: "-15px !important",
      maxWidth: "1218px",
      "&>div": {
        paddingTop: "0px",
        paddingBottom: "0px",
      },
      // [theme.breakpoints.down("1112")]: {
      //   // maxWidth: "75% !important",
      // },
      // [theme.breakpoints.down(1400)]: {
      //   left: "13%",
      //   // maxWidth: "75% !important",
      // },
      // [theme.breakpoints.down(1000)]: {
      //   left: "-2%",
      //   // maxWidth: "75% !important",
      // },
    },
  },
}));

// Create new Rx and Create new Repeat Order Edit Patient Dialog
const DrugsDialog = (props) => {
  const {
    open,
    setOpen,
    searchRepeatOrder,
    patient_id,
    callBackOnSubmitPatientInfo,
    callBackOnCancelPatientInfo,
  } = props;
  const classes = useStyle();
  /** handle close */
  const handleClose = () => {
    setOpen(false);
  };
  /** handle call back on submit */
  const callBackOnSubmit = () => {
    handleClose();
    callBackOnSubmitPatientInfo();
  };
  /** handle call back on cancel */
  const callBackOnCancel = () => {
    handleClose();
    callBackOnCancelPatientInfo();
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"lg"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={classes.rsUpdateDialog}
      >
        <PrimaryDialogTitle
          handleClose={handleClose}
          title="Edit Patient"
          icon={PatientDetails}
        />
        <DialogContent>
          {searchRepeatOrder?.loading ? (
            <PageLoading />
          ) : (
            <PatientsCreateAndEdit
              callBackOnSubmit={callBackOnSubmit}
              callBackOnCancel={callBackOnCancel}
              _patientId={patient_id}
              dialog={true}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DrugsDialog;
